import React from "react";

import * as S from "./style";

export default function Spinner() {
    return (
        <S.Wrapper>
            <div className="spinner">
                <div className="bounce1" />
                <div className="bounce2" />
                <div className="bounce3" />
            </div>
        </S.Wrapper>
    );
}
